import React, { useEffect } from "react";

import Changelog from "./landing/Changelog";

/**
 * ─────────────────────────────────────────────────────────────
 *  Changelog content — add new releases here (newest first).
 *
 *  Each entry supports:
 *    version      "v1.2.0"                       (required)
 *    date         "25 May 2026"                  (optional)
 *    title        "Headline for the release"     (optional)
 *    description  "Short summary paragraph"      (optional)
 *    items        ["Change one", "Change two"]   (optional)
 *    image        "https://.../screenshot.png"   (optional)
 *    button       { url: "https://...", text: "Learn more" }  (optional)
 *
 *  Set CHANGELOG_ENTRIES to [] to show the empty state.
 *  The single entry below is a placeholder — replace it with real notes.
 * ─────────────────────────────────────────────────────────────
 */
const CHANGELOG_ENTRIES = [
  {
    version: "v0.1.0",
    date: "Coming soon",
    title: "Furloop platform — early access",
    description:
      "The first Furloop releases will land here: connected erasure, assessment, reimaging, grading, reporting, and resale workflows in one platform.",
    items: [
      "Connected IT asset recovery workflow",
      "Preflight device checks before processing",
      "Driver capture and reuse across matching devices",
    ],
  },
];

const ChangeLog = () => {
  useEffect(() => {
    document.title = "Changelog — Furloop";
    window.scrollTo(0, 0);
  }, []);

  return (
    <Changelog
      eyebrow="Changelog"
      title="What's new at Furloop"
      description="Product updates, improvements, and fixes across the Furloop IT asset recovery platform."
      entries={CHANGELOG_ENTRIES}
    />
  );
};

export default ChangeLog;
